AppTabs.createTab( {
name: 'test-method-limits',
icon: 'vial',
text: 'Test Method Limits',
create: function(init) {
	'use strict'

	init.setDataTableArgs( {

		tableId: 		'#data-table-test-method-limits',

		readTableName: 	'tblTestMethodLimits',
		editTableName: 	'tblTestMethodLimits',
		primaryKey: 	'TestMethodLimitID',

		canCreate: 			true,
		canEdit: 			true,
		canRemove: 			true,
		canSearch:          true,
		hasColumnFilters: 	true,

		actionData:			'datatable',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		editCallback:		function() {
			window.broadcastLocalStorageUpdateRequest( 'testMethodLimitsMap' );
		},

		fields: [
			{
				label: 		'Test Name',
				columnName: 'TestID',
				isEditable: true,
				type:		'test',
				sort:		'asc',
				render: 	DataTablesManager.getTestNameByID,
			},
			{
				label: 		'Method',
				columnName: 'Method',
				isEditable: true,
			},
			{
				label: 		'LOD / LOQ Ratio',
				columnName: 'LOD_LOQRatio',
				isEditable: true,
			},
			{
				label: 		'LOD',
				columnName: 'LOD',
				isEditable: true,
			},
			{
				label: 		'LOQ',
				columnName: 'LOQ',
				isEditable: true,
			},

		],

	} );
}

} );
